<div class="group-list-content">
  <div *ngIf="formatedGroupList.length || loading; else noGroupList">
    <app-table
      [items]="formatedGroupList"
      [loading]="loading"
      [deleteTitle]="tk.User.UserGroupTitleDeleteConfirmation | t"
      [headers]="headers"
      [columns]="columns"
      [permissions]="groupPermissions"
      [totalRecords]="pagination.total"
      [rows]="pagination.itemsPerPage || 5"
      (sendTablePagination)="handleTablePagination($event)"
      (sendTableAction)="handleTableAction($event)"
      (sendTableSelection)="handleTableSelection($event)"></app-table>
  </div>
  <ng-template #noGroupList>
    <div class="group-list-content__empty">
      <h4>{{ tk.User.NoProfileRegistered | t }}</h4>

      <div class="group-list-content__empty__button" *appHasPermission="groupPermissions.CREATE">
        <app-button
          [id]="'add-group'"
          [label]="tk.User.ToAdd | t"
          [icon]="'pi pi-plus'"
          [type]="'button'"
          (sendButtonClick)="addGroup()"></app-button>
      </div>
    </div>
  </ng-template>
</div>
